export function money(value) {
    const amount = Number(value) || 0;
    return `${amount < 0 ? "-" : ""}$${Math.abs(amount).toLocaleString(undefined, {maximumFractionDigits: 0})}`;
}

export function signed(value) {
    const amount = Number(value) || 0;
    return amount > 0 ? `+${money(amount)}` : money(amount);
}

export function compactMoney(value) {
    const amount = Number(value) || 0;
    const sign = amount < 0 ? "-" : "";
    const absolute = Math.abs(amount);
    if (absolute >= 1000000) return `${sign}$${(absolute / 1000000).toFixed(1)}M`;
    if (absolute >= 1000) return `${sign}$${(absolute / 1000).toFixed(1)}K`;
    return `${sign}$${Math.round(absolute)}`;
}

export function pct(value) {
    return `${((Number(value) || 0) * 100).toFixed(1)}%`;
}

export function metricClass(value) {
    if (value > 0) return "positive";
    if (value < 0) return "negative";
    return "subtle";
}

export function formatDate(value) {
    return new Intl.DateTimeFormat(undefined, {month: "short", day: "numeric", timeZone: "UTC"}).format(new Date(`${value}T00:00:00Z`));
}

export function formatDateTime(value) {
    return value ? new Date(value).toLocaleString() : "—";
}

export function className(value) {
    return String(value || "").replace(/[^a-z_]/g, "_");
}
